import { Injectable } from '@angular/core';

@Injectable()
export class ValidateService {

  constructor() { }

  validateSuscribe(user){
    console.log(user)
  if(user.prenom == undefined || user.nom == undefined || user.email == undefined || user.centre == undefined ||user.profession == ""){
  	return false;
  }else{
  		return true;
  }

  }

  validEmail(e) {
    const filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(e).search (filter) != -1;
}

}



// WEBPACK FOOTER //
// ./src/app/services/validate.service.ts